import React from 'react'
import { Link } from 'react-router-dom'
const Notfound = () => {
    return (
        <section className="bg-white ">
            <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                <div className="mx-auto max-w-screen-sm text-center flex flex-col justify-center items-center">
                    <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-lightGreen font-heading">404</h1>

                    <p className="mb-4 text-xl text-paraGreen ">Sorry, The page you are looking for cannot be found.</p>
                    <Link
                        to='/'
                        className='text-thickGreen w-auto px-6 py-6 rounded-full font-medium border border-thickGreen mt-5 hover:mb-1 bg-transparent 
                   hover:bg-orange hover:text-white hover:border-none text-[20px] leading-[1.112em]   transition-all duration-300 hover:translate-y-[-3px] 
                   block sm:inline-block text-center font-body'
                    >
                       Back to Home Page
                    </Link>
                </div>
            </div>
        </section>
    )
}

export default Notfound
